export default __webpack_public_path__ + "static/story-f3b272f5dc038f3cf3635384b08c8bcc.jpg";